'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var createHasSubmitSucceeded = function createHasSubmitSucceeded(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitSucceeded');
    };
  };
};

exports.default = createHasSubmitSucceeded;


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/lib/selectors/hasSubmitSucceeded.js
 ** module id = 1324
 ** module chunks = 1
 **/